import { useGetFlightInfoQuery, useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { SegmentMiniRulesLoader } from '@/src/components/desktop/itinerary/loadingShimmers'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import RefundBreakupWrapper from './refundBreakup'
import SegmentMiniRules from './segmentMinirules'

const SegmentMiniRulesWrapper = ({
    flightIndex,
    isConfirmationPage = false
}: {
    flightIndex: number
    isConfirmationPage?: boolean
}) => {
    const itineraryId = useGetItineraryId()
    const t = useTranslations('common')
    const { meta } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            skip: isConfirmationPage,
            selectFromResult: ({ data }) => ({
                meta: data?.meta || {}
            })
        }
    )
    const { fareFamilyEnabledOnReview } = meta
    const {
        data,
        isLoading: isFlightMinirulesInfoLoading,
        isUninitialized
    } = useGetFlightInfoQuery(
        {
            itineraryId
        },
        {
            skip: isConfirmationPage || fareFamilyEnabledOnReview
        }
    )

    const miniRuleData = data?.miniRuleResponse?.[flightIndex]
    const { refund = '' } = miniRuleData || {}
    const isRefundable = refund === 'REFUNDABLE'
    const tagText = isRefundable ? t('partiallyRefundable') : t('nonRefundable')

    if (isFlightMinirulesInfoLoading) {
        return <SegmentMiniRulesLoader />
    }
    if (fareFamilyEnabledOnReview || isUninitialized || isEmpty(miniRuleData) || !miniRuleData) {
        return null
    }

    const tooltipContent = isRefundable ? (
        <RefundBreakupWrapper miniRuleData={miniRuleData} />
    ) : (
        <Typography variant="caption" sx={{ fontSize: 14, p: 0.5, display: 'flex', alignItems: 'flex-start' }}>
            {t('nonRefundableNote')}
        </Typography>
    )
    return <SegmentMiniRules tagText={tagText} isRefundable={isRefundable} tooltipContent={tooltipContent} />
}

export default SegmentMiniRulesWrapper
